// src/MessageList.js
import React, {useEffect, useRef, useState} from 'react';
import styles from './ChatBotComponent.module.css';
import Avatar from '../../Assets/Images/Avatar.jpg';
import aiavatar from '../../Assets/svgs/ai-chat-icon.svg';
import {ReactComponent as FillThumbsDown} from '../../Assets/svgs/hand-thumbs-down-fill.svg';
import {ReactComponent as FillThumbsUp} from '../../Assets/svgs/hand-thumbs-up-fill.svg';
import {ReactComponent as ThumbsDown} from '../../Assets/svgs/hand-thumbs-down.svg';
import {ReactComponent as ThumbsUp} from '../../Assets/svgs/hand-thumbs-up.svg';
import {ReactComponent as AiInsights} from '../../Assets/svgs/ai_insights.svg';
import Tooltip from '@mui/material/Tooltip';
import {
  filterOptions,
  R_AND_D_AUTO_SUGGESTIONS,
  restrictedUsers,
} from '../../Common/Constants';
import AdditionalOptions from './AdditionalOptions/AdditionalOptions';
import {callLogEvent, highlightPatterns} from '../../Common/Util';
import DOMPurify from 'dompurify';
import ReorderIcon from '@mui/icons-material/Reorder';
import DWDModal from '../../Common/Components/DWDModal/DWDModal';
import {
  deleteSavedChats,
  getFiltersApi,
  saveChat,
  saveFeedback,
  saveLikeMessage,
} from '../../Services/chat-bot-service';
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import tipsIcon from '../../Assets/Images/tips.png';
import RenderSummary from './RenderSummary';
import RenderSummary_v2 from './RenderSummary_v2';
import {useDispatch} from 'react-redux';
import {useAppSelector} from '../../Store/Store';
import {updateTitle} from '../../Store/chatBotSlice';
import TruncateSummary from './TruncateSummary';

export interface MessageListProps {
  messages: any;
  handleChange?: (event: any) => any;
  setInputValue: any;
  setSuggestions: any;
  isIdeal: any;
  onSend: any;
  title: any;
  disableSummaryBtn: any;
  handleSummary2?: (event: any) => any;
  handleSummary?: (event: any) => any;
}

interface FilterGroup {
  [optionKey: string]: any;
}

interface FilterOptions {
  [category: string]: FilterGroup;
}

const MessageList = ({
  messages,
  setInputValue,
  setSuggestions,
  handleChange,
  isIdeal,
  onSend,
  title,
  disableSummaryBtn,
  handleSummary2,
  handleSummary,
}: MessageListProps) => {
  const currentUserEmail = sessionStorage.getItem('emailid')?.toLowerCase();
  const messagesEndRef = useRef<any>(null);
  const [userQuestions, setUserQuestions] = useState<any>([]);
  const [activeLink, setActiveLink] = useState<any>();
  const questionRefs = useRef<any>([]);
  const answerRef = useRef<any>();
  const [showFeedbackForm, setShowFeedbackForm] = useState<boolean>(false);
  const [currentRecordIndex, setCurrentRecordIndex] = useState<any>();
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [showSavedSuccessMsg, setShowSavedSuccessMsg] = useState<string>('');
  const [filters, setFilters] = useState({
    comparision: 'YTD',
    year: 2025,
    month: 1,
    region: 'ALL',
    retailer: 'ALL',
    productUniverse: 'ALL',
    manufacturer: 'ALL',
    subCategory: 'ALL',
    brand: 'ALL',
    // "insightsType": '',
    kpi: 'Revenue',
  });
  const [summaryIndex, setSummaryIndex] = useState(0);

  const [updatedFilters, setUpdatedFilters] = useState<FilterOptions | null>(
    null
  );
  const [syncFilters, setSyncFilters] = useState(true);

  const handleChangeEvent = (event: SelectChangeEvent) => {
    const {name, value} = event.target;
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    // console.log("filters: ",filters);
  };

  let dispatch = useDispatch();
  let reduxTitle = useAppSelector((state) => state.chatBotDetails.title);

  useEffect(() => {
    if (title != '' && title != null) {
      dispatch(updateTitle(title));
    }
  }, [title]);

  useEffect(() => {
    const messageList = messages.map((item: any, index: number) => ({
      row_number: index,
      ...item,
    }));

    // let tempIndex = 0;
    messages.forEach((element: any, tempIndex: number) => {
      if (
        element.sender == 'summary' &&
        reduxTitle == 'UAE MT' &&
        tempIndex > summaryIndex
      ) {
        setSummaryIndex(tempIndex);
      }
      // tempIndex++;
    });
    setUserQuestions(
      messageList?.filter((msg: any, index: number) => msg?.sender === 123)
    );
  }, [messages]);

  useEffect(() => {
    if (messagesEndRef.current && messages?.length > 1) {
      messagesEndRef.current.scrollIntoView({behavior: 'smooth'});
    }
  }, [messages]);

  const scrollToQuestion = (index: number, message: string) => {
    setActiveLink(index);
    questionRefs.current[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_MESSAGE_HISTORY',
      'clicked on one of the recent messages: ' + message
    );
  };

  const setLatestSuggestions = (
    question: string,
    currentSuggestions: string[]
  ) => {
    setInputValue(question);
    setSuggestions(
      currentSuggestions.filter((suggestion) => suggestion !== question)
    );
  };
  const getSummaryStyles = (summaryInfo: any) => {
    // console.log("title: ",title);
    return reduxTitle == 'FLNA Topline' ? (
      <div
        className={styles.receivedMessage}
        ref={answerRef}
      >
        <h5
          style={{textDecoration: 'underline'}}
          hidden={reduxTitle == 'FLNA Topline' ? false : true}
        >
          Frito-Lay Share Topline Insights Summary
        </h5>
        <TruncateSummary
          text={summaryInfo.chatMessage}
          maxLength={300}
        />
        <br />
        {summaryInfo.images ? summaryInfo.images : ''}
      </div>
    ) : (
      <div className={styles.receivedMessage}>
        <RenderSummary
          rawText={summaryInfo}
          useRef={answerRef}
        />
      </div>
    );
  };

  useEffect(() => {
    if (syncFilters) {
      setUpdatedFilters(filterOptions);
      const fetchDataAsync = async () => {
        try {
          const data = await getFiltersApi();
          setUpdatedFilters((prev) => {
            if (!prev || typeof prev !== 'object') return prev;

            const updated: FilterOptions = {...prev};

            Object.entries(data).forEach(([incomingKey, values]) => {
              const matchKey = Object.keys(prev).find(
                (existingKey) =>
                  incomingKey
                    .toLowerCase()
                    .includes(existingKey.toLowerCase().replace(/\s/g, '')) // remove space from key before match
              );

              if (matchKey && Array.isArray(values)) {
                // Special handling for Sub Category - use custom predefined values
                if (matchKey === 'Sub Category') {
                  const customSubCategories: FilterGroup = {
                    ALL: 'ALL',
                    'Potato Chips': 'Potato Chips',
                    Tortilla: 'Tortilla',
                    Extruded: 'Extruded',
                    'Multigrain/Snack Mix': 'Multigrain/Snack Mix',
                  };
                  updated[matchKey] = customSubCategories;
                } else {
                  const formatted: FilterGroup = {
                    ALL: 'ALL',
                    ...Object.fromEntries(values.map((val) => [val, val])),
                  };
                  updated[matchKey] = formatted;
                }
              }
            });
            setSyncFilters(false);
            return updated;
          });
        } catch (err) {
          console.error('Fetch error:', err);
        }
      };
      fetchDataAsync();
    }
  }, [filters, syncFilters]);

  const getFilterStyles2 = (flag: boolean) => {
    if (flag) {
      return (
        <div className={styles.dropdown}>
          <Stack
            direction='row'
            spacing={2}
            useFlexGap
            sx={{
              flexWrap: 'wrap',
              xs: 2,
              sm: 4,
              md: 4,
              maxWidth: '1000px',
            }}
          >
            {updatedFilters &&
              Object.entries(updatedFilters).map(
                ([category, options], index) => (
                  <FormControl
                    size='small'
                    sx={{
                      minWidth: 150,
                      '& .MuiInputBase-root': {
                        fontSize: '0.65rem',
                        height: '26px',
                        padding: '0 6px',
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '0.65rem',
                        transform: 'translate(14px, 9px) scale(1)',
                        transition: 'all 0.2s ease',
                      },
                      '& .MuiInputLabel-shrink': {
                        transform: 'translate(14px, -6px) scale(0.75)',
                      },
                    }}
                    className={styles.formControl}
                  >
                    <InputLabel
                      id={category}
                      className={styles.inputLabel}
                      sx={{
                        fontSize: '15px',
                        lineHeight: '15px',
                        top: -13,
                      }}
                    >
                      {category === 'KPI' ? 'Metrics' : category}
                    </InputLabel>
                    <Select
                      labelId={category}
                      id={category}
                      value={String(Object.values(filters)[index])}
                      label={category}
                      disabled={syncFilters || disableSummaryBtn}
                      name={Object.keys(filters)
                        .filter((_, i) => i == index)
                        .join()}
                      onChange={handleChangeEvent}
                      sx={{
                        maxWidth: '150px',
                        '& .MuiSelect-displayEmpty': {
                          marginTop: '5px',
                        },
                      }}
                    >
                      {/* <MenuItem sx={{ fontSize: "0.65rem" }} value="">
                        <em>None</em>
                      </MenuItem> */}
                      {Object.entries(options).map(([key, value]) => (
                        <MenuItem
                          sx={{fontSize: '0.65rem'}}
                          value={value}
                        >
                          {key}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )
              )}

            <Button
              onClick={() => {
                handleFilterSummary();
                setSyncFilters(true);
              }}
              variant='contained'
              size='small'
              sx={{
                fontSize: '0.65rem',
                height: '26px',
                minWidth: 100,
                zIndex: 100,
              }}
              disabled={syncFilters || disableSummaryBtn}
            >
              {syncFilters || disableSummaryBtn ? (
                <CircularProgress
                  size={24}
                  disableShrink
                  sx={{
                    color: 'green',
                    padding: '5px',
                  }}
                />
              ) : (
                <AiInsights
                  style={{
                    maxHeight: '25px',
                    maxWidth: '25px',
                    zIndex: 1,
                    marginRight: '0px',
                    marginLeft: '-10px',
                  }}
                />
              )}
              Generate AI Insights
            </Button>
          </Stack>

          <br />
        </div>
      );
    }
  };

  const handleFilterSummary = () => {
    let payload = {
      projName: title,
      time_dimension: 'L1W',
      filters,
    };
    handleSummary2 && handleSummary2(payload);
  };

  const handleFeedback = async (data: any, index: number) => {
    messages[index]['is_liked'] = !messages[index]['is_liked'];
    const req = {
      email: currentUserEmail,
      request_id: data.request_id,
      is_liked: messages[index]['is_liked'],
    };
    handleChange && handleChange(messages);
    setShowSuccessMsg(true);
    setTimeout(() => {
      setShowSuccessMsg(false);
    }, 5000);
    saveLikeMessage(req);
    callLogEvent(
      'CLICKED_NEW_DIALOG_MESSAGE_LIKE_BUTTON',
      'Clicked Like message botton'
    );
  };

  const handleSaveChat = async (data: any, index: number) => {
    messages[index]['is_saved'] = !messages[index]['is_saved'];
    handleChange && handleChange(messages);
    if (messages[index]['is_saved']) {
      const req = {
        email: currentUserEmail,
        request_id: data.request_id,
      };
      saveChat(req);
      setShowSavedSuccessMsg('saved');
    } else {
      const req = {
        email: currentUserEmail,
        request_id: [data.request_id],
      };
      deleteSavedChats(req);
      setShowSavedSuccessMsg('removed');
    }

    setTimeout(() => {
      setShowSavedSuccessMsg('');
    }, 5000);
  };
  const handleFeedbackReason = (data: any, index: number) => {
    setCurrentRecordIndex(index);
    setShowFeedbackForm(true);
  };
  const submitFeedbackReason = (data: any) => {
    callLogEvent(
      'CLICKED_NEW_DIALOG_MESSAGE_DISLIKE_BUTTON_FEEDBACKFORM_SUBMIT',
      'Submitted Feedback form post dislike button click with comments: ' +
        JSON.stringify(data)
    );
    setShowFeedbackForm(true);
    const currentRecord = messages[currentRecordIndex];
    const req = {
      chat_id: 0,
      old_dialog: true,
      request_id: currentRecord.request_id,
      email: currentUserEmail,
      accurate_ans: data.accurate_ans,
      correct_format: data.correct_format,
      correct_sql: data.correct_sql,
      expected_format: data.expected_format,
      other_comments: data.other_comments,
      hash: currentRecord.hash,
    };
    if (messages[currentRecordIndex]['is_liked']) {
      messages[currentRecordIndex]['is_liked'] =
        !messages[currentRecordIndex]['is_liked'];
    }
    messages[currentRecordIndex]['is_disliked'] =
      !messages[currentRecordIndex]['is_disliked'];
    handleChange && handleChange(messages);
    setShowSuccessMsg(true);
    setTimeout(() => {
      setShowSuccessMsg(false);
    }, 5000);
    setShowFeedbackForm(false);
    saveFeedback(req);
  };
  const handleCharts = (msg: any) => {
    onSend(msg);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Snackbar
        open={showSuccessMsg || showSavedSuccessMsg !== ''}
        ContentProps={{
          sx: {
            background: 'green',
          },
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        message={
          showSuccessMsg
            ? 'Thanks for your feedback'
            : showSavedSuccessMsg === 'saved'
            ? 'Chat saved successfully'
            : 'Chat not saved'
        }
        key={'liked'}
      />
      <ul className={styles.anchorul}>
        {userQuestions?.map((question: any, index: any) => (
          <li key={question.row_number}>
            <div
              onClick={() =>
                scrollToQuestion(question.row_number, question.chatMessage)
              }
              className={
                activeLink === question.row_number ? styles.activeLinkClass : ''
              }
              key={index}
            >
              <Tooltip
                title={question.chatMessage}
                placement={'left'}
              >
                {question?.chatMessage}
              </Tooltip>
            </div>
          </li>
        ))}
      </ul>
      <DWDModal
        show={showFeedbackForm}
        handleClose={() => setShowFeedbackForm(false)}
        handleChange={(e: any) => submitFeedbackReason(e)}
        modalName={'feedback'}
      />
      {messages.map((msg: any, index: any) => (
        <div
          key={index}
          className={styles.outerDiv}
        >
          {msg?.sender === 123 ? (
            <>
              <span className={styles.avatar}>
                <img
                  src={Avatar}
                  alt='avatar'
                />
              </span>
              <span className={styles.sentMessage}>
                <div
                  key={index}
                  ref={(el) => (questionRefs.current[index] = el)}
                >
                  {msg.chatMessage}
                </div>
              </span>
              <div ref={messagesEndRef} />
            </>
          ) : (
            <>
              {msg?.sender === 'summary' ? (
                <>
                  <div className={styles.aiChatMessage}>
                    {/* <h5 style={{textDecoration:"underline", marginLeft:"50vh"}} hidden={reduxTitle.trim() != "UAE MT" }>UAE MT Insights Summary</h5> */}
                    {title == 'UAE MT' && index < 1 && (
                      <div>
                        <h5>
                          Please find below the overall summary for UAE Salty
                          Snacks for YTD 2025. To generate focused insights
                          please find the filters at the bottom
                        </h5>
                      </div>
                    )}

                    {getSummaryStyles(msg)}
                    <span className={styles.feedback}>
                      {msg.is_liked ? (
                        <FillThumbsUp
                          onClick={
                            msg.is_disliked
                              ? undefined
                              : () => handleFeedback(msg, index)
                          }
                          className={'cursor-pointer imgSize14 mr15'}
                        />
                      ) : (
                        <ThumbsUp
                          onClick={
                            msg.is_disliked
                              ? undefined
                              : () => handleFeedback(msg, index)
                          }
                          className={'cursor-pointer imgSize14 mr15'}
                        />
                      )}
                      {msg.is_disliked ? (
                        <FillThumbsDown className='imgSize14 mr15' />
                      ) : (
                        <ThumbsDown
                          onClick={() => {
                            callLogEvent(
                              'CLICKED_NEW_DIALOG_MESSAGE_DISLIKE_BUTTON',
                              'Clicked Dislike message botton'
                            );
                            handleFeedbackReason(msg, index);
                          }}
                          className='imgSize14 cursor-pointer mr15'
                        />
                      )}
                    </span>
                    <span className={styles.aiavatar}>
                      <img
                        src={aiavatar}
                        alt='avatar'
                      />
                    </span>
                  </div>
                </>
              ) : (
                <div className={styles.aiChatMessage}>
                  <div
                    className={styles.receivedMessage}
                    ref={answerRef}
                  >
                    {msg.chatMessage}
                    {msg.images ? msg.images : ''}
                    <br />
                  </div>
                  <span className={styles.feedback}>
                    {msg.is_liked ? (
                      <FillThumbsUp
                        onClick={
                          msg.is_disliked
                            ? undefined
                            : () => handleFeedback(msg, index)
                        }
                        className={'cursor-pointer imgSize14 mr15'}
                      />
                    ) : (
                      <ThumbsUp
                        onClick={
                          msg.is_disliked
                            ? undefined
                            : () => handleFeedback(msg, index)
                        }
                        className={'cursor-pointer imgSize14 mr15'}
                      />
                    )}
                    {msg.is_disliked ? (
                      <FillThumbsDown className='imgSize14 cursor-pointer mr15' />
                    ) : (
                      <ThumbsDown
                        onClick={() => handleFeedbackReason(msg, index)}
                        className='imgSize14  cursor-pointer mr15'
                      />
                    )}
                  </span>
                  <span className={styles.aiavatar}>
                    <img
                      src={aiavatar}
                      alt='avatar'
                    />
                  </span>
                </div>
              )}
              <AdditionalOptions
                msg={msg}
                refId={answerRef.current}
                questionRefs={questionRefs?.current[index - 1]}
                handleVisualization={handleCharts}
                handleSavedChats={() => handleSaveChat(msg, index)}
              />
              {reduxTitle == 'UAE MT' &&
                Number(index) == summaryIndex &&
                getFilterStyles2(true)}
              {!restrictedUsers.includes(currentUserEmail!) &&
                msg?.suggestions && (
                  <div className={styles.aiChatMessage}>
                    {msg?.suggestions && (
                      <div className={styles.aiChatMessage}>
                        <div>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 'clamp(8px, 0.83vw, 12px)', // Min: 8px, scales, Max: 12px
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: 'clamp(4px, 0.7vw, 8px)',
                                backgroundColor: '#4197b2',
                                borderRadius: '50%',
                                color: 'white',
                              }}
                            >
                              <ReorderIcon
                                sx={{
                                  fontSize: 'clamp(16px, 1.3vw, 22px)', // Min: 16px, scales, Max: 22px
                                }}
                              />
                            </Box>
                            <Typography
                              sx={{
                                fontSize: 'clamp(14px, 1.1vw, 16px)', // Min: 14px, scales, Max: 16px
                                fontWeight: 'bold',
                              }}
                            >
                              Dialog Cues
                            </Typography>
                          </Box>
                          {msg?.suggestions.map(
                            (x: any, suggestionIndex: number) =>
                              suggestionIndex < 4 && (
                                <p
                                  className={styles.suggestionBtn}
                                  key={suggestionIndex}
                                >
                                  <button
                                    onClick={() =>
                                      !isIdeal
                                        ? undefined
                                        : (callLogEvent(
                                            'CLICKED_NEW_DIALOG_SUGGESTION',
                                            'Clicked on one of the suggestions: ' +
                                              x
                                          ),
                                          setLatestSuggestions(
                                            x,
                                            msg?.suggestions
                                          ))
                                    }
                                  >
                                    {x}
                                  </button>
                                </p>
                              )
                          )}
                          {Number(index) == Number(messages.length - 1) && (
                            <div
                              className={styles.tipsClass}
                              hidden={!isMobile}
                            >
                              <p
                                style={{
                                  fontWeight: 900,
                                  marginBottom: '1px',
                                  fontSize: 13,
                                }}
                              >
                                <img
                                  src={tipsIcon}
                                  className={styles.tipsIcon}
                                  alt='tips'
                                />
                                Tips:
                              </p>
                              <p
                                style={{
                                  fontWeight: 900,
                                  fontSize: 11,
                                  marginBottom: '1px',
                                }}
                              >
                                Structure your question to include: Category,
                                Time, Metrics & Dimensions
                              </p>
                              <p
                                style={{
                                  fontSize: 11,
                                  marginTop: '2px !important',
                                }}
                              >
                                E.g., "Latest 1 Week", dollar share, dollar
                                sales,{' '}
                                <span style={{fontStyle: 'italic'}}>
                                  by Region, Retailer, Channel, Manufacturer, or
                                  Trademark
                                </span>
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </>
          )}
        </div>
      ))}
      {messages.length === 0 &&
        !(localStorage.getItem('DataSource') === 'SpendWise') && (
          <div className={styles.noMessages}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 'clamp(8px, 0.83vw, 12px)', // Min: 8px, scales, Max: 12px
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 'clamp(4px, 0.7vw, 8px)',
                  backgroundColor: '#4197b2',
                  borderRadius: '50%',
                  color: 'white',
                }}
              >
                <ReorderIcon
                  sx={{
                    fontSize: 'clamp(16px, 1.3vw, 22px)', // Min: 16px, scales, Max: 22px
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: 'clamp(14px, 1.1vw, 16px)', // Min: 14px, scales, Max: 16px
                  fontWeight: 'bold',
                }}
              >
                Dialog Cues
              </Typography>
            </Box>
            {R_AND_D_AUTO_SUGGESTIONS.map(
              (x: any, suggestionIndex: number) =>
                suggestionIndex < 4 && (
                  <p
                    className={styles.suggestionBtn}
                    key={suggestionIndex}
                  >
                    <button
                      onClick={() =>
                        !isIdeal
                          ? undefined
                          : (callLogEvent(
                              'CLICKED_NEW_DIALOG_SUGGESTION',
                              'Clicked on one of the suggestions: ' + x
                            ),
                            setLatestSuggestions(x, R_AND_D_AUTO_SUGGESTIONS))
                      }
                    >
                      {x}
                    </button>
                  </p>
                )
            )}
          </div>
        )}
    </>
  );
};

export default MessageList;
